const PAGE_HEADER = 'page-header';
const INLINE_EDIT_FIELD = 'inline-edit-field';

export const PAGE_HEADER_TEST_ID = {
  TITLE_TEXT: `${PAGE_HEADER}-title-text`,
};

export const INLINE_EDIT_FIELD_TEST_ID = {
  INPUT: `${INLINE_EDIT_FIELD}-input`,
  CONFIRM_BUTTON: `${INLINE_EDIT_FIELD}-confirm-button`,
};
